import React from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import { useRef, useEffect, useState } from "react";

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  cursor: pointer;
  background-color: black;
`;

const Bio = styled.div`
  font-family: Roumald;
  font-size: 1.5em;
  color: white;
  width: 80vw;
  padding: 0 10vw 0 10vw;
  height: 100vh;
  line-height: 1.5;
  display: flex;
  align-items: center;
  text-align: center;
`;

export default function About() {
  const wrapperRef = useRef();

  useEffect(() => {}, []);

  return (
    <Link to="/" style={{textDecoration: "none"}}>
      <Wrapper to="/" ref={wrapperRef}>
        <Bio>
          Nina Kunzendorf is a theatre artist and researcher with a background
          in performance design. Her practice explores experimental and
          unconventional forms of dramatic expression. Based in London, Nina has
          worked on a wide array of projects across theatre, opera, dance,
          visual arts, and film. <br></br>
          <br></br>As a set designer, she has assisted Isabelle Krötsch
          (Kammerspiele, Munich), Anna Fleischle (Apollo Theatre, London), Loren
          Elstein (The Welsh National Opera, Cardiff), and Laura Hopkins (Leeds
          Playhouse, Leeds), among others. In 2019, she was awarded the Goethe
          Institute’s Support for Newcomer Talent for her devised play, The Ship
          Sank. Where on Deck Did My Captain Lie?, which premiered at the
          Edinburgh Festival Fringe. Since 2025, Nina has also been creating
          work as part of the multimedia collective DOLORES, founded by actor
          Pía Laborde-Noguez. <br></br>
          <br></br> Nina is currently an interdisciplinary PhD candidate at
          Goldsmiths, University of London, affiliated with the Department of
          Politics and the Department of Theatre and Performance. Her research
          focuses on female revenge in contemporary performance.
        </Bio>
      </Wrapper>
    </Link>
  );
}
